import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(private readonly auth: AuthService, private readonly router: Router) { }

  /**
   * Return 'true' if the user is not logged in, so user can go to the login page.
   * Otherwise redirect to the 'success_path'.
   * @param next 
   * @param state 
   */
  public async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    if (await this.canLogin()) {
      const success_path: string = <string>this.auth.success_path;
      this.router.navigateByUrl(success_path);
      return false;
    }
    return true;
  }

  private async canLogin(): Promise<boolean> {
    const token: string | undefined = this.auth.token;
    if (!token) {
      return false;
    }
    return await this.auth.login(token).toPromise();
  }
}
